var teapot = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-sc/teapot.jpg';
var teapot34view = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-sc/teapot34view.jpg';
var reliquary = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-sc/reliquary.jpg';
var sugarbowl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-sc/sugarbowl.jpg';
var creamer = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-sc/creamer.jpg';
var tallneckedvase = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-sc/tallneckedvase.jpg';

export const allImagesDesktopOrderClaySC = [
    [/*COLUMN 1*/
        [
            {
                name: teapot34view,
                artistName: "Lorraine Shemesh",
                title: "Teapot 3/4 View",
                year: "1998",
                dimensions: "13 x 10 x 4 in., low fire clay",
                link: "claysc2",
                privateCollection: ""
            },
            {
                name: teapot,
                artistName: "Lorraine Shemesh",
                title: "Teapot",
                year: "1998",
                dimensions: "13 x 10 x 4 in., low fire clay",
                link: "claysc1",
                privateCollection: ""
            }
        ],
        [
            {
                name: reliquary,
                artistName: "Lorraine Shemesh",
                title: "Reliquary",
                year: "1999",
                dimensions: "10 1/2 x 16 1/2 x 5 in., low fire clay",
                link: "claysc3",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: tallneckedvase,
                artistName: "Lorraine Shemesh",
                title: "Tall Necked Vase",
                year: "1998",
                dimensions: "23 x 14 x 4 in., low fire clay",
                link: "claysc6",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {    
                name: creamer,
                artistName: "Lorraine Shemesh",
                title: "Creamer",
                year: "1999",
                dimensions: "4 1/4 x 5 1/2 x 3 in., low fire clay",
                link: "claysc5",
                privateCollection: ""
            }
        ],
        [
            {
                name: sugarbowl,
                artistName: "Lorraine Shemesh",
                title: "Sugar Bowl",
                year: "1999",
                dimensions: "4 1/4 x 4 x 2 1/2 in., low fire clay",
                link: "claysc4",
                privateCollection: ""
            }
        ]
    ]          
]

export const allImagesMobileOrderClaySC = [
    [{
        name: teapot34view,
        artistName: "Lorraine Shemesh",
        title: "Teapot 3/4 View",
        year: "1998",
        dimensions: "13 x 10 x 4 in., low fire clay",
        link: "claysc2",
        privateCollection: ""
    },
    {
        name: teapot,
        artistName: "Lorraine Shemesh",
        title: "Teapot",
        year: "1998",
        dimensions: "13 x 10 x 4 in., low fire clay",
        link: "claysc1",
        privateCollection: ""
    },
    {
        name: reliquary,
        artistName: "Lorraine Shemesh",
        title: "Reliquary",
        year: "1999",
        dimensions: "10 1/2 x 16 1/2 x 5 in., low fire clay",
        link: "claysc3",
        privateCollection: ""
    },
    {
        name: tallneckedvase,
        artistName: "Lorraine Shemesh",
        title: "Tall Necked Vase",
        year: "1998",
        dimensions: "23 x 14 x 4 in., low fire clay",
        link: "claysc6",
        privateCollection: ""
    },
    {    
        name: creamer,
        artistName: "Lorraine Shemesh",
        title: "Creamer",
        year: "1999",
        dimensions: "4 1/4 x 5 1/2 x 3 in., low fire clay",
        link: "claysc5",
        privateCollection: ""
    },
    {
        name: sugarbowl,
        artistName: "Lorraine Shemesh",
        title: "Sugar Bowl",
        year: "1999",
        dimensions: "4 1/4 x 4 x 2 1/2 in., low fire clay",
        link: "claysc4",
        privateCollection: ""
    }]      
]
